import { useState } from "react"
import FormComp from "../../Componentes/FormComp"
import Overlay from "../../Componentes/Overlay"
import Formulario from "../../Componentes/Utils/Formulario"
import Modal from "../../Componentes/Utils/Modal"
import axios from "axios"

const ModalNewEmail = ({ clinica, referencia, fecharModal, fetchSuccess, item }) => {

    const [ email, setEmail ] = useState( item?.email ?? '' )

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        try{

            const formData = new FormData()

            formData.append('clinica', clinica)
            formData.append('referencia', referencia)
            formData.append('email', email)

            if( item ){

                formData.append('id', item.id )

            }

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/ASO/SaveNewEmail/', formData, { withCredentials: true });

            console.log( data )

            await fetchSuccess()
            fecharModal()

        }catch( e ){

            console.error( e );

        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal header close={ fecharModal } >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="E-MAIL"
                            type="email"
                            changeFunc={( e ) => setEmail( e.target.value )}
                            valor={ email }
                            required
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )

}

export default ModalNewEmail;